__turbopack_context__.v({
  "hasTransition": "read-more-wrapper-module-scss-module__fIkcbW__hasTransition",
  "isCollapsed": "read-more-wrapper-module-scss-module__fIkcbW__isCollapsed",
  "wrapper": "read-more-wrapper-module-scss-module__fIkcbW__wrapper",
});
